import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const ProductDetails = () => {
  const { id } = useParams(); // Get product ID from URL
  const navigate = useNavigate();
  const [plant, setPlant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlant = async () => {
      try {
      const response = await axios.get(`${API_URL}/api/products/getproduct/${id}`);
        setPlant(response.data);
      } catch (error) {
        console.error("Failed to load product:", error);
        alert("Product not found.");
        navigate("/"); // Redirect to homepage or show fallback
      } finally {
        setLoading(false);
      }
    };

    fetchPlant();
  }, [id, navigate]);

  if (loading) {
    return <div className="text-center py-10 text-gray-600">Loading product details...</div>;
  }

  if (!plant) {
    return <div className="text-center py-10 text-red-500">Product not found.</div>;
  }

  const addToCart = async () => {
    const token = localStorage.getItem("token");
    const userId = sessionStorage.getItem("userid");

    if (!token || !userId) {
      const guestCart = JSON.parse(localStorage.getItem("guest_cart")) || [];
      const existingIndex = guestCart.findIndex(
        (item) => item.productId === plant._id || item.productId === plant.id
      );

      if (existingIndex > -1) {
        guestCart[existingIndex].quantity += 1;
      } else {
        guestCart.push({
          productId: plant._id || plant.id,
          title: plant.title,
          price: plant.price,
          image: plant.image,
          quantity: 1,
        });
      }

      localStorage.setItem("guest_cart", JSON.stringify(guestCart));
      alert("Product added to cart!");
      return;
    }

    try {
      const payload = {
        userId,
        productId: plant._id || plant.id,
        quantity: 1,
      };

      const response = await axios.post(`${API_URL}/api/cart/add`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      alert(response.data?.message || "Product added to cart!");
    } catch (error) {
      console.error("Add to cart error:", error);
      if (error.response?.status === 401) {
        alert("Authentication failed. Please log in again.");
        navigate("/login");
      } else {
        alert("Failed to add product to cart.");
      }
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">{plant.title}</h1>

      <div className="grid md:grid-cols-2 gap-6">
        <img
          src={
            plant.image
              ? plant.image.startsWith("http")
                ? plant.image
                : `${API_URL}${plant.image}`
              : "https://via.placeholder.com/400"
          }
          alt={plant.title}
          className="w-full max-h-[500px] object-contain rounded-md"
        />

        <div>
          <p className="mb-2"><span className="font-semibold text-gray-700">Price:</span> ₹{plant.price}</p>
        <p className="mb-2">
  <span className="font-semibold text-gray-700">Category:</span>{" "}
  {plant.categories?.length > 0 ? plant.categories.join(", ") : "N/A"}
</p>

          <p className="mb-2">
            <span className="font-semibold text-gray-700">Availability:</span>{" "}
            <span className={plant.stock > 0 ? "text-green-600" : "text-red-600"}>
              {plant.stock > 0 ? "In Stock" : "Out of Stock"}
            </span>
          </p>
          {plant.stock > 0 && plant.stock <= 3 && (
            <p className="text-orange-500 text-sm mb-2">Hurry! Only {plant.stock} left</p>
          )}

          <p className="mt-4 text-gray-700 leading-relaxed">
            <span className="font-semibold">Description:</span><br />
            {plant.description || "No description available."}
          </p>

          <button
            onClick={addToCart}
            disabled={plant.stock <= 0}
            className={`mt-6 w-full px-4 py-2 rounded-md text-white font-medium transition-all ${
              plant.stock > 0
                ? "bg-green-600 hover:bg-green-700"
                : "bg-gray-400 cursor-not-allowed"
            }`}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
